<template>
    <div>
        <iframe height="100%" width=100% :src="getFilePath"></iframe>
    </div>
</template>

<script>
    export default {
        name: 'PDFJSViewer',
        props: {
            fileName: String,
        },
        computed: {
            getFilePath() {
                var fileName = this.fileName;

                if (!fileName)
                    fileName = "";

                console.log(fileName);
                return '/wwwroot/lib/pdfjs-2.5.207-dist/web/viewer.html?file=' + fileName;
            }
        }
    }
</script>
<style scoped>
    div {
        width: 100%;
        height: 80vh;
    }
</style>